import * as React from 'react';

type Props = {
  content: string;
};
export const SimpleTextFormat = ({ content }: Props) => {
  return (
    <>
      {content.split(/(\n)/g).map((t, i) => (
        <React.Fragment key={`${crypto.randomUUID()}`}>{t === '\n' ? <br /> : t}</React.Fragment>
      ))}
    </>
  );
};
